import React from 'react';

export default function ExperienceHeader() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900">Professional Experience</h2>
      <p className="mt-1 text-gray-600">
        List your work history, starting with your most recent position. Focus on achievements and 
        responsibilities that are relevant to your target role.
      </p>
    </div>
  );
}